export default __webpack_public_path__ + "img/trial-img-c4e8f6363d7b078eb5cc45c37dd96cc6.png";